import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export function CTAButton({
  children,
  className = '',
  href = 'https://protocolo-3c-chatear-conectar-concretar.impultienda.ar/checkout',
  size = 'lg'
}: Props) {
  const pad = size === 'lg' ? 'px-8 text-[18px] pt-[17px] pb-[17px]' : 'px-6 text-base pt-[14px] pb-[14px]';
  return <a href={href} className={cn('group inline-flex items-center justify-center gap-2 rounded-full bg-azul font-extrabold uppercase tracking-wide text-white shadow-[0_10px_40px_-8px_rgba(47,111,237,0.65)] ring-1 ring-gold/40 transition-all duration-200 hover:-translate-y-0.5 hover:bg-azul-deep hover:shadow-[0_16px_50px_-8px_rgba(47,111,237,0.8)] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold', pad, className)} data-id="element-49" data-mp="2p09m62vby17n">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-50" data-mp="38pk0bcffge3n" />
    </a>;
}